import React, { useState, useEffect, useRef } from 'react';
import { FaBookReader } from 'react-icons/fa';

const AutoScroll = () => {
  const [isAutoScrolling, setIsAutoScrolling] = useState(false);
  const [scrollSpeed, setScrollSpeed] = useState(50); // Default medium speed
  const scrollInterval = useRef(null);
  const lastScrollPosition = useRef(0);

  // Convert speed (1-100) to scroll interval (100-10ms)
  const getScrollInterval = () => 110 - scrollSpeed;

  const startAutoScroll = () => {
    if (scrollInterval.current) clearInterval(scrollInterval.current);
    
    scrollInterval.current = setInterval(() => {
      // Check if we've reached the bottom (with 10px tolerance)
      const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;
      
      if (isAtBottom) {
        stopAutoScroll();
        return;
      }
      
      // Save current position for pause detection
      lastScrollPosition.current = window.scrollY;
      
      // Scroll down by a small amount
      window.scrollBy({
        top: 1,
        behavior: 'instant'
      });
      
      // Check if scrolling actually happened (user might have manually scrolled up)
      if (window.scrollY === lastScrollPosition.current) {
        stopAutoScroll();
      }
    }, getScrollInterval());
  };

  const stopAutoScroll = () => {
    if (scrollInterval.current) {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
    }
    setIsAutoScrolling(false);
  };

  const toggleAutoScroll = () => {
    if (isAutoScrolling) {
      stopAutoScroll();
    } else {
      setIsAutoScrolling(true);
      startAutoScroll();
    }
  };

  useEffect(() => {
    // Clean up on unmount
    return () => {
      stopAutoScroll();
    };
  }, []);

  useEffect(() => {
    // Adjust speed when slider changes
    if (isAutoScrolling) {
      startAutoScroll();
    }
  }, [scrollSpeed]);

  // Pause auto-scroll if user manually scrolls up
//   useEffect(() => {
//     const handleScroll = () => {
//       if (isAutoScrolling && window.scrollY < lastScrollPosition.current) {
//         stopAutoScroll();
//       }
//       lastScrollPosition.current = window.scrollY;
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [isAutoScrolling]);

  return (
    <div className="auto-scroll-controls">
      <label className="auto-scroll-toggle">
        <input
          type="checkbox"
          checked={isAutoScrolling}
          onChange={toggleAutoScroll}
        />
        <FaBookReader className="reading-icon" />
        <span>القراءة التلقائية</span>
      </label>
      
      {isAutoScrolling && (
        <div className="speed-control">
          <span>Slow</span>
          <input
            type="range"
            min="1"
            max="100"
            value={scrollSpeed}
            onChange={(e) => setScrollSpeed(parseInt(e.target.value))}
            className="speed-slider"
          />
          <span>Fast</span>
        </div>
      )}
    </div>
  );
};

export default AutoScroll;